import serverInit from "@/plugins/init/server"
import clientInit from "@/plugins/init/client"
import { noStoreInfo } from "@/utils/utils"
/**
 * 初始化数据
 * @param {*} context
 * @returns
 */
export const bootstrapData = async ({ store, req }) => {
  return await store.dispatch("bootstrapData", { req })
}

export default async function (context, inject) {
  const { $cookies, store } = context
  // 若cookie中LOGIN_FLAG为true时，走服务端初始化逻辑，否则走客户端初始化逻辑
  // 读取后端区分网站的配置, 动态的load  css
  if (process.server) {
    await serverInit(context)
    const LOGIN_FLAG = $cookies.get("LOGIN_FLAG")
    if (LOGIN_FLAG || noStoreInfo($cookies)) {
      await bootstrapData(context)
    }
    $cookies.remove("LOGIN_FLAG")
  } else {
    clientInit(context)
    const { isServerInit } = store.state
    const commonParams = isServerInit ? await store.dispatch("getCommonParamsSet") : await bootstrapData(context)
    if (isServerInit) {
      // 设置本地存储数据
      await store.dispatch("setStorageData")
    }
    if (commonParams) {
      inject("commonParams", commonParams)
    }
  }
}
